// removed by extract-text-webpack-plugin
module.exports = {"title-wrapper":"title-wrapper","titleWrapper":"title-wrapper","email-sent-success":"email-sent-success","emailSentSuccess":"email-sent-success","form-notification-message-wrapper":"form-notification-message-wrapper","formNotificationMessageWrapper":"form-notification-message-wrapper","show":"show","change-password-error-message-wrapper":"change-password-error-message-wrapper","changePasswordErrorMessageWrapper":"change-password-error-message-wrapper","change-password-sub-title":"change-password-sub-title","changePasswordSubTitle":"change-password-sub-title"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/forgotPasswordFlow/changePasswordForm/style.scss
// module id = 961
// module chunks = 0